<div class="tabs-container" *ngIf="slice && slice['slice_type'] === 'tabs'">
  <div class="tabs">
    <h3
      class="tab"
      *ngFor="let tab of slice.items; let i = index"
      [class.current]="currentTab === i"
      (click)="currentTab = i"
    >
      {{ tab['tab_heading'] }}
    </h3>
  </div>
  <div class="tab-panes">
    <div *ngFor="let tab of slice.items; let i = index">
      <div class="tab-pane" [class.show]="currentTab === i">
        {{ tab['tab_content'] | marked }}
      </div>
    </div>
  </div>
</div>
